import { registerFormInputComponent } from "@vendure/admin-ui/core";
import { CountrySelectorComponent } from "./country-selector";
import { StateSelectorComponent } from "./state-selector";

export default [
  registerFormInputComponent("state-selector", StateSelectorComponent),
  registerFormInputComponent("country-selector-v2", CountrySelectorComponent),
];
